<template>
  <b-row>
    <b-col sm="6" class="border-right">
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="date_du"><strong>Date de réception du</strong></label>
        </b-col>
        <b-col sm="4">
          <b-form-input class="input_date" type="date" id="date_du" size="sm" v-model="date_du"></b-form-input>
        </b-col>
        <b-col sm="1">
          <label for="date_au"><strong>Au</strong></label>
        </b-col>
        <b-col sm="4">
          <b-form-input class="input_date" type="date" id="date_au" size="sm" v-model="date_au"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="gestionnaire"><strong>Statut du dossier : </strong></label>
        </b-col>
        <b-col sm="9">
            <b-form-select v-model="statusId" :options="selectStatusOption" @change="manageSelectedStatus()">
              <template v-slot:first>
                <b-form-select-option :value="null">-- Tous --</b-form-select-option>
              </template>
            </b-form-select>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="canal"><strong>Canal : </strong></label>
        </b-col>
        <b-col sm="9">
          <multiselect v-model="canal" tag-placeholder="Choisissez un canal" placeholder="Choisissez un canal" label="name" track-by="code" :options="allCanals" :multiple="true" :taggable="true"></multiselect>
            <!-- <b-form-select size="sm" v-model="canal" :options="allCanals" multiple :select-size="3"></b-form-select> -->
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="segment"><strong>Segment : </strong></label>
        </b-col>
        <b-col sm="9">
          <multiselect v-model="segment" tag-placeholder="Choisissez un segment" placeholder="Choisissez un segment" label="name" track-by="code" :options="allSegments" :multiple="true" :taggable="true"></multiselect>
            <!-- <b-form-select size="sm" v-model="segment" :options="allSegments" multiple :select-size="3"></b-form-select> -->
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="type"><strong>Type : </strong></label>
        </b-col>
        <b-col sm="9">
          <multiselect v-model="type" tag-placeholder="Choisissez un type" placeholder="Choisissez un type" label="name" track-by="code" :options="allTypes" :multiple="true" :taggable="true"></multiselect>
            <!-- <b-form-select size="sm" v-model="type" :options="allTypes" multiple :select-size="3"></b-form-select> -->
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="produit"><strong>Famille produit : </strong></label>
        </b-col>
        <b-col sm="9">
          <multiselect v-model="produit" tag-placeholder="Choisissez un produit" placeholder="Choisissez un produit" label="name" track-by="code" :options="allProduits" :multiple="true" :taggable="true"></multiselect>
            <!-- <b-form-select size="sm" v-model="produit" :options="allProduits" multiple :select-size="3"></b-form-select> -->
        </b-col>
      </b-row>
    </b-col>
    <b-col sm="6">
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="nom"><strong>Nom : </strong></label>
        </b-col>
        <b-col sm="9">
            <b-form-input type="text" id="nom" v-model="nom" placeholder=""></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="prenom"><strong>Prenom : </strong></label>
        </b-col>
        <b-col sm="9">
            <b-form-input type="text" id="prenom" v-model="prenom" placeholder=""></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="nir"><strong>NIR</strong></label>
        </b-col>
        <b-col sm="4">
            <b-form-input type="text" id="nir" v-model="nir" placeholder="Commence par..."></b-form-input>
        </b-col>
        <b-col sm="2">
          <label for="idpp"><strong>IDPP</strong></label>
        </b-col>
        <b-col sm="3">
            <b-form-input type="text" id="idpp" v-model="idpp" placeholder="N° NSI"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="rar"><strong>N° RAR</strong></label>
        </b-col>
        <b-col sm="9">
            <b-form-input type="text" id="rar" v-model="rar" placeholder=""></b-form-input>
        </b-col>
      </b-row>
      <hr>
      <b-row class="mb-1">
        <b-col sm="3">
          <label for="gestionnaire"><strong>Gestionnaire affecté : </strong></label>
        </b-col>
        <b-col sm="9">
            <!-- <b-form-input type="text" id="gestionnaire" v-model="gestionnaire" placeholder=""></b-form-input> -->
            <auto-select
              v-model="gestionnaire"
              :items="gestionnaires"
              :loading="loadingGestionnaire"
              item-value="id"
              item-text="nom"
              :placeholder="gestionnaire ? '' : 'Entrer le nom du gestionnaire'"
              disable-filtering-by-search
              @search="onSearchGestionnaire"
              v-on:keyup.enter="onEnter()"
            >
              <template #no-data>
                {{ noData ? "Aucun gestionnaire trouvé." : "Il faut au moins 2 caractères pour la recherche." }}
              </template>
              <template slot="item" slot-scope="{ item: gest }">
                <div style="display: flex; align-items: center;" @click="onClick($event, gest)">
                  <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                </div>
              </template>
              <template slot="selection" slot-scope="{ item: gest }">
                <div style="display: flex; align-items: center;">
                  <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                </div>
              </template>
              <template v-if="loadingGestionnaire" #input-end>
                <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
              </template>
            </auto-select>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import {en, fr} from 'vuejs-datepicker/dist/locale'
import Multiselect from 'vue-multiselect'
import { CoolSelect as AutoSelect } from 'vue-cool-select'

export default {
  props: [
    'clearTheForm'
  ],
  components: {
    Multiselect,
    AutoSelect,
  },
  data() {
    return {
      balId: "",
      statusId: null,
      statusIds: [],
      nir: "",
      gestionnaire: "",
      gestionnaireNom: "",
      gestionnairePrenom: "",
      gestionnaires: [],
      date_du: "",
      date_au: "",
      nom: "",
      prenom: "",
      rar: "",
      basketName: "",
      basketForAll: "",
      selectStatusOption: [],
      produit: [],
      allProduits: [],
      // selectedProduits: [],
      segment: [],
      allSegments: [],
      // selectedSegments: [],
      canal: [],
      allCanals: [],
      // selectedCanals: [],
      type: [],
      allTypes: [],
      // selectedTypes: [],
      garantie: "",
      loadingGestionnaire: false,
      timeoutId: null,
      noData: false,
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()
  },
  async mounted() {
    await this.getCanals()
    await this.getTypes()
    await this.getSegments()
    await this.getProduits()
console.log(this.$parent)
    this.getStatus()
    // repeuplement du form suite retour d'une fiche
    // this.populateSegment()
    // this.populateType()
    // this.populateCanal()
    // this.populateProduit()
  },
  watch: {
    clearTheForm: function() {
      if (this.clearTheForm) {
        this.clearForm()
        this.$parent.clearTheForm = false
      }
    },
    canal: function() {
      if (this.canal) {
        console.log('avant : ',this.$parent.selectedCanals)
        this.$parent.selectedCanals = this.canal.map( item => item.code)
        console.log('après : ',this.$parent.selectedCanals)
      } else {
        this.$parent.selectedCanals = []
      }
    },
    type: function() {
      if (this.type) {
        this.$parent.selectedTypes = this.type.map( item => item.code)
      } else {
        this.$parent.selectedTypes = []
      }
    },
    segment: function() {
      if (this.segment) {
        this.$parent.selectedSegments = this.segment.map( item => item.code)
      } else {
        this.$parent.selectedSegments = []
      }
    },
    produit: function() {
      if (this.produit) {
        this.$parent.selectedProduits = this.produit.map( item => item.code)
      } else {
        this.$parent.selectedProduits = []
      }
    }
  },
  methods: {
    onClick(event, item){
      this.gestionnaireNom = item.nom
      this.gestionnairePrenom = item.prenom
    },
    onEnter(){
      for(let gest of this.gestionnaires) {
        if (this.gestionnaire === gest.id) {
          this.gestionnaireNom = gest.nom
          this.gestionnairePrenom = gest.prenom
        }
      }
    },
    async onSearchGestionnaire(search) {
      let self = this
      const lettersLimit = 2

      this.noData = false
      if (search.length < lettersLimit) {
        this.gestionnaires = []
        this.loadingGestionnaire = false
        return
      }
      this.loadingGestionnaire = true

      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(async () => {
        this.$axios
          .get("/espaceGestion/gestionnaire/autocompleteRecherche?query="+search+"&type=gestion-qc")
          .then(response => {
            // console.log(response)
            this.loadingGestionnaire = false
            this.gestionnaires = response.data
            if (!this.gestionnaires.length) this.noData = true
          })
          .catch(function(error) {
            console.log(error)
            self.loadingGestionnaire = false
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
              showConfirmButton: false,
              timer: 5000
            })
          })
      }, 500)
    },
    async getStatus() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/espaceGestion/dossier/dashboardAllStatus")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          this.allStatus = response.data.status
          // this.selectStatusOption.push({value: null, text: '-- Choisissez un statut --'})
          for (let status of response.data.status) {
            this.selectStatusOption.push({value: status.id, text: status.libelle_bo})
          }
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    async getCanals() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      await this.$axios
        .get("/espaceGestion/dossier/getAllCanal")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          for(let canal of response.data.data){
            this.allCanals.push({code: canal.id, name: canal.libelle})
          }
          // this.allCanals = response.data.data
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    async getTypes() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      await this.$axios
        .get("/espaceGestion/dossier/getAllType")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          for(let type of response.data.data){
            this.allTypes.push({code: type.id, name: type.libelle})
          }
          // this.allTypes = response.data.data
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    async getSegments() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      await this.$axios
        .get("/espaceGestion/dossier/getAllSegment")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          for(let segment of response.data.data){
            this.allSegments.push({code: segment.id, name: segment.libelle})
          }
          // this.allSegments = response.data.data
          // console.log('dans getSegment allSegments : ',this.allSegments)
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    async getProduits() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      await this.$axios
        .get("/espaceGestion/dossier/getAllProduit")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          for(let produit of response.data.data){
            this.allProduits.push({code: produit.id, name: produit.libelle})
          }
          // this.allProduits = response.data.data
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    populateSegment() {
      this.segment = []
      for (let segmentId of this.$parent.selectedSegments) {
        let name = ""
        for (let segment of this.allSegments) {
          if (segment.code === segmentId) {
            name = segment.name
          }
        }
        
        this.segment.push({code: segmentId, name: name})
      }
    },
    populateCanal() {
      this.canal = []
      for (let canalId of this.$parent.selectedCanals) {
        let name = ""
        for (let canal of this.allCanals) {
          if (canal.code === canalId) {
            name = canal.name
          }
        }
        this.canal.push({code: canalId, name: name})
      }
    },
    populateType() {
      this.type = []
      for (let typeId of this.$parent.selectedTypes) {
        let name = ""
        for (let type of this.allTypes) {
          if (type.code === typeId) {
            name = type.name
          }
        }
        this.type.push({code: typeId, name: name})
      }
    },
    populateProduit() {
      this.produit = []
      for (let produitId of this.$parent.selectedProduits) {
        let name = ""
        for (let produit of this.allProduits) {
          if (produit.code === produitId) {
            name = produit.name
          }
        }
        this.produit.push({code: produitId, name: name})
      }
    },
    clearForm() {
      this.balId = ""
      this.statusId = null
      this.statusIds = []
      this.nir = ""
      this.gestionnaire = ""
      this.gestionnaireNom = ""
      this.gestionnairePrenom = ""
      this.date_du = ""
      this.date_au = ""
      this.nom = ""
      this.prenom = ""
      this.rar = ""
      this.basketName = ""
      this.basketForAll = ""
      this.produit = []
      // this.selectedProduits = []
      this.segment = []
      // this.selectedSegments = []
      this.canal = []
      // this.selectedCanals = []
      this.type = []
      // this.selectedTypes = []
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

</style>
